import React, { useEffect } from 'react';
import {
  Table,
  Tbody,
  Tr,
  Td,
  TableContainer,
  Thead,
  Th,
  Text,
  IconButton,
  Input,
  Button,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
// import { chemical } from '../../Utils/chemical_test_data';
import { Stack, Flex } from '@chakra-ui/react';
import styled from 'styled-components';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { SearchIcon } from '@chakra-ui/icons';
import { chemicaldata } from '../../Utils/api';
export default function Chemical_data(props) {
  const history = useHistory();
  const [value, setValue] = React.useState('');
  const handleChange = (event) => setValue(event.target.value);
  const [page, setPage] = React.useState({ currentPage: 1, HPage: 1 });
  const [chemical, setChemical] = React.useState([]);
  const [data, setData] = React.useState([]);
  const title = [
    '物質代碼',
    '名稱',
    '物質種類',
    '濃度開始',
    '濃度結束',
    '使用行為',
    '核發日期',
    '有效日期',
  ];
  useEffect(() => {
    chemicaldata(props.certName).then((res) => {
      setChemical(res.data);
      pagination(res.data, 1);
    });
  }, []);
  function pagination(jsonData, nowPage) {
    const dataTotal = jsonData.length;
    const perpage = 17;
    const pageTotal = Math.ceil(dataTotal / perpage);
    let currentPage = Math.min(nowPage, pageTotal);
    const minData = (currentPage - 1) * perpage;
    const maxData = currentPage * perpage;
    let data = jsonData.slice(minData, maxData);
    setPage((prePage) => ({
      ...prePage,
      pageTotal: pageTotal,
      dataTotal: dataTotal,
      currentPage: currentPage,
    }));
    displayData(data);
    displaybutton(pageTotal, page.HPage);
  }
  function displayData(data) {
    const displayChemical = data.map(
      (
        {
          toxic_no,
          chemical_name,
          material_type,
          concentration_Q11,
          concentration_Q12,
          act,
          issue_date,
          valid_date,
        },
        index,
      ) => (
        <Tr key={index}>
          <DisplayTable>{toxic_no}</DisplayTable>
          <DisplayTable>{chemical_name}</DisplayTable>
          <DisplayTable>{material_type}</DisplayTable>
          <DisplayTable>{concentration_Q11}</DisplayTable>
          <DisplayTable>{concentration_Q12}</DisplayTable>
          <DisplayTable>{act}</DisplayTable>
          <DisplayTable>{issue_date.substr(0, 10)}</DisplayTable>
          <DisplayTable>{valid_date.substr(0, 10)}</DisplayTable>
        </Tr>
      ),
    );
    setData(displayChemical);
  }
  function displaybutton(total, HPage) {
    let str = '';
    const button = document.getElementById('page_button');
    let TPage = Math.min(total, HPage + 5);

    for (let i = HPage; i <= TPage; i++) {
      str += `<li class="page-item" style="
            padding: 5px 15px;
            border-right: 2px solid #07B464;
        "><a class="page-link" href="#" data-page="${i}">${i}</a></li>`;
    }

    button.innerHTML = str;
  }
  function switchButton(moveBack) {
    if (moveBack) {
      if (page.HPage + 6 <= page.pageTotal) {
        let newH = page.HPage + 1;
        setPage((prePage) => ({ ...prePage, HPage: newH }));
        displaybutton(page.pageTotal, newH);
      }
    } else {
      if (page.HPage - 1) {
        let newH = page.HPage - 1;
        setPage((prePage) => ({ ...prePage, HPage: newH }));
        displaybutton(page.pageTotal, newH);
      }
    }
  }
  function switchPage(e) {
    e.preventDefault();
    if (e.target.nodeName !== 'A') return;
    const page = e.target.dataset.page;
    pagination(chemical, page);
  }
  function SearchData() {
    if (value == '') {
      pagination(chemical, 1);
    } else {
      // let newdata = [];
      let data = chemical.filter((item) => {
        return item.toxic_no == value;
      });
      // newdata.push(data);
      pagination(data, 1);
    }
  }
  return (
    <Flex w="100%" minH="calc(100vh - 64px - 58px)" flexDirection={'column'}>
      {props.show && (
        <Flex alignItems="center" justify="space-between" m="2vh 2vw">
          <IconButton
            minW="30px"
            h="30px"
            borderRadius="30px"
            bgColor="#07B464"
            mt="10px"
            ml="50px"
            aria-label="Search database"
            icon={<ArrowBackIcon />}
            cursor="pointer"
            onClick={() => history.goBack()}
          ></IconButton>
          <Flex>
            <Text minW="85px">搜尋條件 : </Text>
            <Input
              h="36px"
              w="220px"
              placeholder="請輸入Toxic_No"
              border="solid 2px #A8B8C2"
              mr="10px"
              value={value}
              onChange={handleChange}
            />
            <Button
              border="solid 2px #005AA3"
              color="black"
              bg="#EAF5FF"
              borderRadius="15px"
              h="36px"
              w="95px"
              onClick={() => SearchData()}
            >
              <SearchIcon color="#005AA3" mr="5px" />
              搜尋
            </Button>
          </Flex>
        </Flex>
      )}
      <Stack margin="auto" mt="0px">
        <TableContainer textAlign="center">
          <Table variant="simple">
            <Thead>
              <Tr>
                {title.map((e, index) => (
                  <Th
                    fontSize="14px"
                    textAlign="center"
                    border="1px solid #BAC7D5"
                    key={index}
                  >
                    {e}
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody id="chemical_context">
              {data.length > 0 ? (
                data
              ) : (
                <tr height="70vh">
                  <td colSpan={title.length}>No data found</td>
                </tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        <Flex justify={'flex-end'} alignItems={'center'} m="15px 0px">
          <Text mr="10px" padding="5px">
            {page.currentPage}/{page.pageTotal}頁 共{page.dataTotal}筆
          </Text>
          <Flex border="solid 2px #07B464" borderRadius="10px" h="34px">
            <IconButton
              icon={<ChevronLeftIcon />}
              h="31px"
              borderRight="2px solid #07B464"
              borderLeftRadius="10px"
              borderRightRadius="0px"
              color="black"
              bgColor="white"
              cursor="pointer"
              onClick={() => switchButton(false)}
            />
            <ButtonAll id="page_button" onClick={switchPage} />
            <IconButton
              icon={<ChevronRightIcon />}
              h="31px"
              borderRadius="10px"
              color="black"
              bgColor="white"
              cursor="pointer"
              onClick={() => switchButton(true)}
            />
          </Flex>
        </Flex>
      </Stack>
    </Flex>
  );
}
const ButtonAll = styled.object`
  list-style: none;
  display: flex;
  align-items: center;
`;
const DisplayTable = styled(Td)`
  text-align: center;
  border: 1px solid #bac7d5;
  height: 32px;
`;
